import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import uiActions from 'core/ui/actions';
import { withStyles } from 'theme/withStyles';
import BottomContent from 'common/BottomContent';
import ErrorMsg from 'common/ErrorMsg';
import OutputFunding from 'fields/OutputFunding';
import ButtonRowGroup from './common/ButtonRowGroup';
import RawHtml from '../common/RawHtml';

import commonStyles from './styles';
import fundingButtonRowStyles from './styles/fundingButtonRow';

const styles = (theme) => {
  const common = commonStyles(theme);

  return {
    ...common,
    editAmount: {
      display: 'block',
      margin: '0 auto',
      position: 'relative',
      top: -30,
    },
    fundingButtonRow: fundingButtonRowStyles(theme),
  };
};

const FundingTransferIntBare = ({
  backAllowed,
  backButtonLabel,
  bottomContent,
  children,
  classes,
  hasFields,
  label,
  labelMobile,
  name,
  onBack,
  resources,
  subText,
}) => (
  <>
    <legend
      className={classnames('grp-label', classes.label)}
      role={!hasFields ? 'presentation' : undefined}
    >
      <RawHtml type="span" className={classnames('desktop', classes.desktopLabel)}>
        {label}
      </RawHtml>
      <RawHtml type="span" className={classnames('mobile', classes.mobileLabel)}>
        {labelMobile}
      </RawHtml>
    </legend>
    <div className={classnames('funding-transfer-int-group-view', classes.fundingButtonRow)}>
      <RawHtml className={classnames('content', classes.content)}>{subText}</RawHtml>

      <ErrorMsg name={name} type="group" />

      <div className="row">
        <div className={classnames('region-fields', classes.fields)}>{children}</div>
        <OutputFunding name="appRequest_totalFundingAmount" groupName={name} />

        {backAllowed && (
          <RawHtml
            className={classnames(
              'btn btn-mobile btn-tertiary btn-grp-back mt-5 edit-amount',
              classes.editAmount,
            )}
            data-name="btn-grp-back"
            type="button"
            onClick={onBack}
            variant="secondary"
          >
            {backButtonLabel}
          </RawHtml>
        )}

        <div>
          {resources.disclosureTitle && (
            <RawHtml type="strong">{resources.disclosureTitle}</RawHtml>
          )}
          <br />
          {resources.disclosureSubtext && <RawHtml>{resources.disclosureSubtext}</RawHtml>}
        </div>
        <BottomContent className="bottomContent">{bottomContent}</BottomContent>

        <ButtonRowGroup groupName={name} />
      </div>
    </div>
  </>
);

FundingTransferIntBare.propTypes = {
  backAllowed: PropTypes.bool.isRequired,
  backButtonLabel: PropTypes.string,
  bottomContent: PropTypes.string,
  children: PropTypes.node.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  hasFields: PropTypes.bool,
  label: PropTypes.string,
  labelMobile: PropTypes.string,
  name: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired,
  resources: PropTypes.objectOf(PropTypes.string),
  subText: PropTypes.string,
};

FundingTransferIntBare.defaultProps = {
  backButtonLabel: '',
  bottomContent: '',
  hasFields: false,
  label: '',
  labelMobile: '',
  resources: {},
  subText: '',
};

const mapStateToProps = ({ groups, page }, { name }) => {
  const group = groups[name];
  return {
    backAllowed: page.backAllowed || Object.keys(groups)[0] !== name,
    backButtonLabel: group.backButtonLabel,
    bottomContent: group.bottomContent,
    hasFields: group?.fields?.length > 0 ?? false,
    label: group.label,
    labelMobile: group.labelMobile,
    resources: group.resources,
    subText: group.subText,
  };
};

const FundingTransferIntStyled = withStyles(styles)(FundingTransferIntBare);

export default connect(mapStateToProps, {
  onBack: () => uiActions.setActiveGroup('FUNDING_AMOUNT'),
})(FundingTransferIntStyled);
